/* LWL — Sepet sayfası özeti: alt çubuk, "Sepet Detayı" paneli, ön bilgilendirme onayı, "Tükeniyor!" etiketleri.
   İşaretleme: snippets/lwl-sepet-ozet.liquid (tema sepeti yeniden çizince yeniden gelir; olaylar belgeye bağlı). */
(function () {
	'use strict';
	if (window.__lwlSepet) return;
	window.__lwlSepet = true;
	var mq = window.matchMedia('(max-width: 989px)');
	var raf = 0;

	function page() { return document.querySelector('[data-lso="page"]'); }
	function layer(r, name) { return r && r.querySelector('[data-lso-' + name + ']'); }

	function sync() {
		raf = 0;
		var p = page();
		document.body.classList.toggle('lso-on', !!p);
		if (p) document.body.classList.toggle('lwl-ai-lift', mq.matches);
		[].forEach.call(document.querySelectorAll('[data-lso]'), function (r) {
			var box = r.closest('#CartDrawer') || r.closest('.cart-template__content') || document;
			(r.getAttribute('data-low') || '').split(',').forEach(function (k) {
				if (!k) return;
				var img = box.querySelector('[data-cart-item="' + k.replace(/"/g, '') + '"] .cart-item__image-container');
				if (img && !img.querySelector('.lso-badge')) img.insertAdjacentHTML('beforeend', '<span class="lso-badge">Tükeniyor!</span>');
			});
		});
	}
	function queue() { if (!raf) raf = requestAnimationFrame(sync); }

	function show(r, name, open) {
		var el = layer(r, name);
		if (!r || !el) return;
		el.hidden = !open;
		if (name === 'sheet') {
			r.classList.toggle('is-open', open);
			var b = r.querySelector('[data-lso-open]');
			if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
		}
		var any = document.querySelector('[data-lso="page"] .lso__layer:not([hidden])');
		document.documentElement.classList.toggle('lso-lock', !!any);
		if (open && name === 'consent') { var ok = el.querySelector('[data-lso-ok]'); if (ok) ok.focus(); }
	}
	function closeAll(r) {
		var list = r ? [r] : document.querySelectorAll('[data-lso]');
		[].forEach.call(list, function (x) { show(x, 'sheet', false); show(x, 'consent', false); });
	}

	function checkout(r, btn) {
		var box = r.closest('#CartDrawer') || document.querySelector('.cart-template__footer') || document;
		window.__lsoGoing = true;
		btn.disabled = true;
		btn.textContent = 'Ödeme sayfası açılıyor…';
		var done = false;
		function go() {
			if (done) return; done = true;
			var cb = box.querySelector('.js-terms-and-conditions-checkbox');
			if (cb && !cb.checked) { cb.checked = true; cb.dispatchEvent(new Event('change', { bubbles: true })); }
			var b = box.querySelector('.js-cart-footer-checkout');
			if (b) { b.disabled = false; b.removeAttribute('disabled'); b.click(); }
			setTimeout(function () { window.location.href = '/checkout'; }, 2500);
		}
		try {
			fetch('/cart/update.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ attributes: { _on_bilgilendirme_onay: new Date().toISOString() } })
			}).then(go, go);
		} catch (e) { go(); }
		setTimeout(go, 1500);
	}

	/* Tema sepet değişince çekmecenin alt kısmını yeniden çizmiyor: sepet isteği bitince özeti kendimiz tazeleriz */
	var rt = 0;
	function sectionId(el) { var s = el && el.closest('[id^="shopify-section-"]'); return s ? s.id.replace('shopify-section-', '') : ''; }
	function refreshOne(old, url) {
		return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
			var d = document.createElement('div'); d.innerHTML = h;
			var mode = old.getAttribute('data-lso');
			var n = d.querySelector('[data-lso="' + mode + '"]');
			if (!old.isConnected) return;
			if (n) old.replaceWith(n); else old.remove();
			queue();
		});
	}
	function refresh() {
		rt = 0;
		var dr = document.querySelector('#CartDrawer [data-lso="drawer"]');
		if (dr) { var id = sectionId(dr); if (id) refreshOne(dr, '/?section_id=' + encodeURIComponent(id) + '&_lso=' + Date.now()).catch(function () {}); }
		var pg = page();
		if (pg) { var pid = sectionId(pg); if (pid) refreshOne(pg, '/cart?section_id=' + encodeURIComponent(pid) + '&_lso=' + Date.now()).catch(function () {}); }
	}
	function later() { if (window.__lsoGoing) return; clearTimeout(rt); rt = setTimeout(refresh, 350); }
	var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
	if (window.fetch && !window.fetch.__lso) {
		var of = window.fetch;
		window.fetch = function (input) {
			var u = typeof input === 'string' ? input : (input && input.url) || '';
			var p = of.apply(this, arguments);
			if (CART_RE.test(u)) p.then(later, later);
			return p;
		};
		window.fetch.__lso = true;
	}
	var oo = XMLHttpRequest.prototype.open;
	XMLHttpRequest.prototype.open = function (m, u) {
		if (CART_RE.test(String(u))) this.addEventListener('loadend', later);
		return oo.apply(this, arguments);
	};

	document.addEventListener('click', function (e) {
		var t = e.target, r = t.closest && t.closest('[data-lso]');
		if (!r) return;
		var g = t.closest('[data-lso-gain]');
		if (g) {
			e.preventDefault();
			var sub = g.nextElementSibling, open = g.getAttribute('aria-expanded') !== 'true';
			g.setAttribute('aria-expanded', open ? 'true' : 'false');
			if (sub) sub.hidden = !open;
			return;
		}
		if (t.closest('[data-lso-open]')) { e.preventDefault(); var s = layer(r, 'sheet'); show(r, 'sheet', !!(s && s.hidden)); return; }
		if (t.closest('[data-lso-go]')) { e.preventDefault(); show(r, 'sheet', false); show(r, 'consent', true); return; }
		var ok = t.closest('[data-lso-ok]');
		if (ok) { e.preventDefault(); checkout(r, ok); return; }
		if (t.closest('[data-lso-close]')) { e.preventDefault(); closeAll(r); }
	});
	document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
	if (mq.addEventListener) mq.addEventListener('change', queue);

	function start() { sync(); new MutationObserver(queue).observe(document.body, { childList: true, subtree: true }); }
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
